export function cleanHTML(html: string) {
  // Create a temporary DOM element
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = html;

  // Remove all style attributes
  tempDiv.querySelectorAll('[style]').forEach((el) => el.removeAttribute('style'));

  // Remove all font-related attributes and tags
  tempDiv.querySelectorAll('span, font').forEach((el) => {
    el.replaceWith(...el.childNodes);
  });

  return tempDiv.innerHTML;
}
